import { render, staticRenderFns } from "./MaterialStatsCard.vue?vue&type=template&id=77106d40"
import script from "./MaterialStatsCard.vue?vue&type=script&lang=ts"
export * from "./MaterialStatsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaterialStatsCard.vue?vue&type=style&index=0&id=77106d40&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports